import { render, staticRenderFns } from "./SuggestionsDatatable.vue?vue&type=template&id=51c9b7c3"
import script from "./SuggestionsDatatable.vue?vue&type=script&lang=js"
export * from "./SuggestionsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports